/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-hm': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd"><path pid="0" d="M8.373 17.358c.208-.261.716-.712 1.752-.712.807 0 1.77.888 2.042 1.196l.777.87.894-.75c.016-.013 1.606-1.316 5.1-1.316 2.333 0 3.943.682 4.689 1.082v3.475H26V10.95h-2.373v4.174c-1.115-.436-2.694-.85-4.69-.85-2.857 0-4.724.724-5.74 1.283-.698-.58-1.807-1.282-3.072-1.282-.672 0-1.252.116-1.752.298V10.95H6v10.254h2.373v-3.845z" _fill="#FFF"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-hm.js